var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232.09 232.09",
    style: {
      enableBackground: "new 0 0 232.09 232.09"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 39.92,
    cy: 60.41,
    r: 11.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "51.3,60.41 77,60.41 94.99,90.88 109.76,90.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -132.6342 168.1581)",
    className: "st0",
    cx: 39.92,
    cy: 167.87,
    rx: 11.38,
    ry: 11.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "51.3,167.87 77,167.87 94.99,137.41 109.76,137.41  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72.84,
    cy: 192.06,
    r: 11.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 84.22,
    y1: 192.06,
    x2: 109.76,
    y2: 192.06
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72.84,
    cy: 36.22,
    r: 11.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 84.22,
    y1: 36.22,
    x2: 109.76,
    y2: 36.22
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 64.24,
    cy: 88.67,
    r: 11.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 64.24,
    cy: 139.61,
    r: 11.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 29.39,
    cy: 114.14,
    r: 11.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 40.77,
    y1: 114.14,
    x2: 109.76,
    y2: 114.14
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 94.47,
    y1: 168.74,
    x2: 108.47,
    y2: 168.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 94.47,
    y1: 59.41,
    x2: 108.47,
    y2: 59.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.87,94.08c0.7,11.53,10.62,20.32,22.15,19.62c11.54-0.7,20.32-10.62,19.62-22.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.33,89.19c0.67-11.54,10.56-20.35,22.1-19.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.48,165.23c2.81-11.21-4-22.57-15.22-25.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.26,28c-11.56,0-20.92,9.37-20.92,20.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.78,58.8c-13,0-23.53,10.54-23.53,23.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.02,137.44c13,0,23.53-10.54,23.53-23.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.41,156.25c-15.54,0-28.14,12.6-28.14,28.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.35,142.17c0-5.75-2.33-10.96-6.08-14.75c2.69-3.83,4.29-8.48,4.29-13.52c0-7.88-3.89-14.84-9.84-19.11 c2.26-3.62,3.59-7.88,3.59-12.46c0-12.36-9.54-22.48-21.65-23.44c1.61-2.96,2.52-6.36,2.52-9.97c0-11.56-9.37-20.92-20.92-20.92 c-0.89,0-1.77,0.07-2.63,0.18c-3.75-5.64-10.15-9.36-17.43-9.36c-11.41,0-20.67,9.13-20.9,20.49h-0.02v144.56h0.01 c0,0.17-0.01,0.34-0.01,0.52c0,15.54,12.6,28.14,28.14,28.14c12.87,0,23.72-8.65,27.06-20.44c9.67-1.84,16.99-10.33,16.99-20.54 c0-3.05-0.67-5.94-1.84-8.56C202.14,161.88,210.35,152.98,210.35,142.17z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AIIcon.adfa3e697dc8bf5a6289eac3aa61ab35.svg";
export { ForwardRef as ReactComponent };